/** Categorías de archivo permitidas en entregas (alineado con backend/core/upload_limits.py). */
export const TIPOS_ARCHIVO_ENTREGA = [
  { id: 'imagen', label: 'Imagen', extensiones: ['png', 'jpeg', 'jpg'] },
  { id: 'script', label: 'Script', extensiones: ['py', 'js', 'html', 'css'] },
  { id: 'pdf', label: 'PDF', extensiones: ['pdf'] },
  { id: 'rar', label: 'RAR', extensiones: ['rar'] },
  { id: 'zip', label: 'ZIP', extensiones: ['zip'] },
];

export const TIPOS_ARCHIVO_IDS = new Set(TIPOS_ARCHIVO_ENTREGA.map((t) => t.id));

export function parseExtensionesScript(str) {
  if (!str || typeof str !== 'string') return [];
  const set = new Set();
  str.split(',').forEach((item) => {
    const clean = item.trim().replace(/^\./, '').toLowerCase();
    if (clean) set.add(clean);
  });
  return [...set];
}

export function extensionesDesdeCategorias(categorias, extensionesScript = null) {
  const set = new Set();
  const customScripts = parseExtensionesScript(extensionesScript);
  (categorias || []).forEach((id) => {
    if (id === 'script' && customScripts.length > 0) {
      customScripts.forEach((ext) => set.add(ext));
    } else {
      const cat = TIPOS_ARCHIVO_ENTREGA.find((t) => t.id === id);
      if (cat) cat.extensiones.forEach((ext) => set.add(ext.toLowerCase()));
    }
  });
  return set;
}

/** Tareas antiguas sin tipos_archivo_entrega: todas las extensiones del catálogo. */
export function categoriasArchivoParaTarea(tarea) {
  const cats = tarea?.tipos_archivo_entrega;
  if (cats && cats.length > 0) return cats;
  return TIPOS_ARCHIVO_ENTREGA.map((t) => t.id);
}

export function todasLasExtensionesArchivo() {
  return extensionesDesdeCategorias(TIPOS_ARCHIVO_ENTREGA.map((t) => t.id));
}

/** Texto para mostrar al estudiante qué puede subir. */
export function etiquetaTiposArchivo(categorias, extensionesScript = null) {
  const exts = [...extensionesDesdeCategorias(categorias, extensionesScript)].sort();
  if (exts.length === 0) return '';
  return exts.map((e) => `.${e}`).join(', ');
}

export function etiquetaCategoriasArchivo(categorias) {
  return (categorias || [])
    .map((id) => TIPOS_ARCHIVO_ENTREGA.find((t) => t.id === id)?.label || id)
    .filter(Boolean)
    .join(', ');
}

export function archivoPermitido(file, categorias, extensionesScript = null) {
  const permitidas = extensionesDesdeCategorias(categorias, extensionesScript);
  if (permitidas.size === 0) return true;
  const name = (file?.name || '').trim();
  const ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
  return ext && permitidas.has(ext);
}
